'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PLACEMENTS_HORIZ = exports.PLACEMENTS_HORIZ = ['left', 'right'];
var PLACEMENTS_VERT = exports.PLACEMENTS_VERT = ['top', 'bottom'];

var PLACEMENTS_SIDES = exports.PLACEMENTS_SIDES = PLACEMENTS_HORIZ.concat(PLACEMENTS_VERT);

var PLACEMENTS = exports.PLACEMENTS = PLACEMENTS_SIDES.concat(['left top', 'left bottom', 'right top', 'right bottom', 'top left', 'top right', 'bottom left', 'bottom right']);

var OPPOSITE_DIRECTIONS = exports.OPPOSITE_DIRECTIONS = {
  top: 'bottom',
  bottom: 'top',
  left: 'right',
  right: 'left',
  middle: 'middle',
  center: 'center'
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/tooltip/PlacementConstants.js
// module id = 33
// module chunks = 0